import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

/** Heater shield — a shield with a soft inner curve. Carries a
 *  "guarded boundary" reading without feeling militaristic; the inner
 *  arc hints at a filtering / moderating policy below. Used for
 *  reader-comment moderation and similar policy surfaces. */
export function IcnShield(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="shield">
      <path d="M8 2 13 4v4.5c0 3.2-2.4 5.4-5 6-2.6-.6-5-2.8-5-6V4l5-2z" />
      <path d="M5.5 8.25c1.5 1.6 3.5 1.6 5 0" />
    </Svg>
  );
}
